/*
 * Filename: cq-app-store.ts
 * Description: his file act as a top level store to store model dependencies.It is a root store for mobx-state-tree.
 */

import { types } from 'mobx-state-tree';
import { CQAuthModel ,CQActivityLoaderModel , CQErrorManagerModel , CQSuccessModel, CQInformationModel } from './models';
import { CQAppConstant } from '../app-constants';


/** 
* @description App Store Model Initialize
*/

export const CQAppModel = types.model({
    loader: CQActivityLoaderModel,
    error:  CQErrorManagerModel,
    authentication: CQAuthModel,
    success: CQSuccessModel,
    informational: CQInformationModel
});

/** 
 * @description App Store Creation
 */
export const CQAppStore = CQAppModel.create({
    authentication:
    {
        isUserLoggedIn: false,
        accessToken: '',
        jwtAccessToken: '',
        isJWTAccessTokenValid: false
    },
    loader: {   
        activityIndicatorFlag: false,
        showDeployementStatus:false
    },
    error: {
        errorType: CQAppConstant.ERROR_GENERIC,
        errorMessage: '',
        componentName: '',
        errorFlag: false
    },
    success: {
        successMessage: '',
        componentName: '',
        successFlag: false
    },
    informational:{
        informationalMessage:'',
        componentName:'',
        informationalFlag: false
    }
});

export type ICQAppStore = typeof CQAppModel.Type;
